"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenBalance = exports.PositionPool = exports.LockedCoinsRecord = exports.LockedCoins = exports.Metadata = exports.BalanceChange = exports.Token = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const wrappers_1 = require("../../../google/protobuf/wrappers");
exports.protobufPackage = "Switcheo.carbon.coin";
const baseToken = {
    id: "",
    creator: "",
    denom: "",
    name: "",
    symbol: "",
    decimals: long_1.default.ZERO,
    bridgeId: long_1.default.UZERO,
    chainId: long_1.default.UZERO,
    tokenAddress: "",
    bridgeAddress: "",
    isActive: false,
    createdBlockHeight: long_1.default.UZERO,
};
exports.Token = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.creator !== "") {
            writer.uint32(18).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.name !== "") {
            writer.uint32(34).string(message.name);
        }
        if (message.symbol !== "") {
            writer.uint32(42).string(message.symbol);
        }
        if (!message.decimals.isZero()) {
            writer.uint32(48).int64(message.decimals);
        }
        if (!message.bridgeId.isZero()) {
            writer.uint32(56).uint64(message.bridgeId);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(64).uint64(message.chainId);
        }
        if (message.tokenAddress !== "") {
            writer.uint32(74).string(message.tokenAddress);
        }
        if (message.bridgeAddress !== "") {
            writer.uint32(82).string(message.bridgeAddress);
        }
        if (message.isActive === true) {
            writer.uint32(88).bool(message.isActive);
        }
        if (!message.createdBlockHeight.isZero()) {
            writer.uint32(104).uint64(message.createdBlockHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.name = reader.string();
                    break;
                case 5:
                    message.symbol = reader.string();
                    break;
                case 6:
                    message.decimals = reader.int64();
                    break;
                case 7:
                    message.bridgeId = reader.uint64();
                    break;
                case 8:
                    message.chainId = reader.uint64();
                    break;
                case 9:
                    message.tokenAddress = reader.string();
                    break;
                case 10:
                    message.bridgeAddress = reader.string();
                    break;
                case 11:
                    message.isActive = reader.bool();
                    break;
                case 13:
                    message.createdBlockHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseToken);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        message.symbol =
            object.symbol !== undefined && object.symbol !== null
                ? String(object.symbol)
                : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromString(object.decimals)
                : long_1.default.ZERO;
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        message.tokenAddress =
            object.tokenAddress !== undefined && object.tokenAddress !== null
                ? String(object.tokenAddress)
                : "";
        message.bridgeAddress =
            object.bridgeAddress !== undefined && object.bridgeAddress !== null
                ? String(object.bridgeAddress)
                : "";
        message.isActive =
            object.isActive !== undefined && object.isActive !== null
                ? Boolean(object.isActive)
                : false;
        message.createdBlockHeight =
            object.createdBlockHeight !== undefined &&
                object.createdBlockHeight !== null
                ? long_1.default.fromString(object.createdBlockHeight)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        message.decimals !== undefined &&
            (obj.decimals = (message.decimals || long_1.default.ZERO).toString());
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        message.tokenAddress !== undefined &&
            (obj.tokenAddress = message.tokenAddress);
        message.bridgeAddress !== undefined &&
            (obj.bridgeAddress = message.bridgeAddress);
        message.isActive !== undefined && (obj.isActive = message.isActive);
        message.createdBlockHeight !== undefined &&
            (obj.createdBlockHeight = (message.createdBlockHeight || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseToken);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.creator = (_b = object.creator) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.name = (_d = object.name) !== null && _d !== void 0 ? _d : "";
        message.symbol = (_e = object.symbol) !== null && _e !== void 0 ? _e : "";
        message.decimals =
            object.decimals !== undefined && object.decimals !== null
                ? long_1.default.fromValue(object.decimals)
                : long_1.default.ZERO;
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        message.tokenAddress = (_f = object.tokenAddress) !== null && _f !== void 0 ? _f : "";
        message.bridgeAddress = (_g = object.bridgeAddress) !== null && _g !== void 0 ? _g : "";
        message.isActive = (_h = object.isActive) !== null && _h !== void 0 ? _h : false;
        message.createdBlockHeight =
            object.createdBlockHeight !== undefined &&
                object.createdBlockHeight !== null
                ? long_1.default.fromValue(object.createdBlockHeight)
                : long_1.default.UZERO;
        return message;
    },
};
const baseBalanceChange = {
    address: "",
    blockHeight: long_1.default.UZERO,
    denom: "",
    amount: "",
    type: "",
    location: "",
};
exports.BalanceChange = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (!message.blockHeight.isZero()) {
            writer.uint32(16).uint64(message.blockHeight);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(34).string(message.amount);
        }
        if (message.type !== "") {
            writer.uint32(42).string(message.type);
        }
        if (message.location !== "") {
            writer.uint32(50).string(message.location);
        }
        if (message.metadata !== undefined) {
            exports.Metadata.encode(message.metadata, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseBalanceChange);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.blockHeight = reader.uint64();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.type = reader.string();
                    break;
                case 6:
                    message.location = reader.string();
                    break;
                case 7:
                    message.metadata = exports.Metadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseBalanceChange);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.blockHeight =
            object.blockHeight !== undefined && object.blockHeight !== null
                ? long_1.default.fromString(object.blockHeight)
                : long_1.default.UZERO;
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        message.location =
            object.location !== undefined && object.location !== null
                ? String(object.location)
                : "";
        message.metadata =
            object.metadata !== undefined && object.metadata !== null
                ? exports.Metadata.fromJSON(object.metadata)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.blockHeight !== undefined &&
            (obj.blockHeight = (message.blockHeight || long_1.default.UZERO).toString());
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.type !== undefined && (obj.type = message.type);
        message.location !== undefined && (obj.location = message.location);
        message.metadata !== undefined &&
            (obj.metadata = message.metadata
                ? exports.Metadata.toJSON(message.metadata)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseBalanceChange);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.blockHeight =
            object.blockHeight !== undefined && object.blockHeight !== null
                ? long_1.default.fromValue(object.blockHeight)
                : long_1.default.UZERO;
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        message.type = (_d = object.type) !== null && _d !== void 0 ? _d : "";
        message.location = (_e = object.location) !== null && _e !== void 0 ? _e : "";
        message.metadata =
            object.metadata !== undefined && object.metadata !== null
                ? exports.Metadata.fromPartial(object.metadata)
                : undefined;
        return message;
    },
};
const baseMetadata = {};
exports.Metadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.orderId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.orderId }, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMetadata);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.orderId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMetadata);
        message.orderId =
            object.orderId !== undefined && object.orderId !== null
                ? String(object.orderId)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.orderId !== undefined && (obj.orderId = message.orderId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMetadata);
        message.orderId = (_a = object.orderId) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
const baseLockedCoins = {
    denom: "",
    orderMargin: "",
    positionMargin: "",
};
exports.LockedCoins = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.orderMargin !== "") {
            writer.uint32(18).string(message.orderMargin);
        }
        if (message.positionMargin !== "") {
            writer.uint32(26).string(message.positionMargin);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseLockedCoins);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.orderMargin = reader.string();
                    break;
                case 3:
                    message.positionMargin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseLockedCoins);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.orderMargin =
            object.orderMargin !== undefined && object.orderMargin !== null
                ? String(object.orderMargin)
                : "";
        message.positionMargin =
            object.positionMargin !== undefined && object.positionMargin !== null
                ? String(object.positionMargin)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.orderMargin !== undefined &&
            (obj.orderMargin = message.orderMargin);
        message.positionMargin !== undefined &&
            (obj.positionMargin = message.positionMargin);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseLockedCoins);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.orderMargin = (_b = object.orderMargin) !== null && _b !== void 0 ? _b : "";
        message.positionMargin = (_c = object.positionMargin) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseLockedCoinsRecord = { address: "", marketId: "" };
exports.LockedCoinsRecord = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.marketId !== "") {
            writer.uint32(18).string(message.marketId);
        }
        if (message.lockedCoins !== undefined) {
            exports.LockedCoins.encode(message.lockedCoins, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseLockedCoinsRecord);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.marketId = reader.string();
                    break;
                case 3:
                    message.lockedCoins = exports.LockedCoins.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseLockedCoinsRecord);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.lockedCoins =
            object.lockedCoins !== undefined && object.lockedCoins !== null
                ? exports.LockedCoins.fromJSON(object.lockedCoins)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.marketId !== undefined && (obj.marketId = message.marketId);
        message.lockedCoins !== undefined &&
            (obj.lockedCoins = message.lockedCoins
                ? exports.LockedCoins.toJSON(message.lockedCoins)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseLockedCoinsRecord);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.marketId = (_b = object.marketId) !== null && _b !== void 0 ? _b : "";
        message.lockedCoins =
            object.lockedCoins !== undefined && object.lockedCoins !== null
                ? exports.LockedCoins.fromPartial(object.lockedCoins)
                : undefined;
        return message;
    },
};
const basePositionPool = { marketId: "" };
exports.PositionPool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.marketId !== "") {
            writer.uint32(10).string(message.marketId);
        }
        for (const v of message.coins) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePositionPool);
        message.coins = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketId = reader.string();
                    break;
                case 2:
                    message.coins.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, basePositionPool);
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.coins = ((_a = object.coins) !== null && _a !== void 0 ? _a : []).map((e) => coin_1.Coin.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.marketId !== undefined && (obj.marketId = message.marketId);
        if (message.coins) {
            obj.coins = message.coins.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.coins = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, basePositionPool);
        message.marketId = (_a = object.marketId) !== null && _a !== void 0 ? _a : "";
        message.coins = ((_b = object.coins) !== null && _b !== void 0 ? _b : []).map((e) => coin_1.Coin.fromPartial(e));
        return message;
    },
};
const baseTokenBalance = {
    available: "",
    order: "",
    position: "",
    denom: "",
};
exports.TokenBalance = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.available !== "") {
            writer.uint32(10).string(message.available);
        }
        if (message.order !== "") {
            writer.uint32(18).string(message.order);
        }
        if (message.position !== "") {
            writer.uint32(26).string(message.position);
        }
        if (message.denom !== "") {
            writer.uint32(34).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTokenBalance);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.available = reader.string();
                    break;
                case 2:
                    message.order = reader.string();
                    break;
                case 3:
                    message.position = reader.string();
                    break;
                case 4:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseTokenBalance);
        message.available =
            object.available !== undefined && object.available !== null
                ? String(object.available)
                : "";
        message.order =
            object.order !== undefined && object.order !== null
                ? String(object.order)
                : "";
        message.position =
            object.position !== undefined && object.position !== null
                ? String(object.position)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.available !== undefined && (obj.available = message.available);
        message.order !== undefined && (obj.order = message.order);
        message.position !== undefined && (obj.position = message.position);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseTokenBalance);
        message.available = (_a = object.available) !== null && _a !== void 0 ? _a : "";
        message.order = (_b = object.order) !== null && _b !== void 0 ? _b : "";
        message.position = (_c = object.position) !== null && _c !== void 0 ? _c : "";
        message.denom = (_d = object.denom) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
